import PubSub from "underpub-js";

var ContentTextMediaTypeOne = function (options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ContentTextMediaTypeOne',
	};

	$.extend(true, this.options, options);

};

ContentTextMediaTypeOne.prototype.init = function () {

	var self = this;

};

document.addEventListener("DOMContentLoaded", () => {
	const accordionButtons = document.querySelectorAll(".mol-ContentTextMediaTypeOne__infoIconItem .el-CardAccordionInfo__toggle");
	const sliders = document.querySelectorAll(".mol-ContentTextMediaTypeOne__carousel");

	accordionButtons.forEach((button, index) => {
		button.addEventListener("click", (l) => {
			sliders.forEach( (imageEl) => {
				imageEl.classList.remove('active');
			});
			sliders[index].classList.add("active");
		});
	});
});

export default ContentTextMediaTypeOne;
